







































import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "network-requirements-component",
})
export default class NetworkRequirementsComponent extends Vue {
  copyPortList(): void {
    const p = document.getElementById("port-list");
    const range = document.createRange();
    range.selectNode(p);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }
  isHawkings(): boolean {
    if (window.location.host.includes("hawkings.education")) return true;
    else return false;
  }
}
